import { createFileRoute } from '@tanstack/react-router';
import { EventsPage } from '@/modules/events/public';

export const Route = createFileRoute('/_aberto/eventos/')({
  component: EventsPage,
});
